import { render, staticRenderFns } from "./Setup2FA.vue?vue&type=template&id=1ea95b9b&scoped=true&"
import script from "./Setup2FA.vue?vue&type=script&lang=ts&"
export * from "./Setup2FA.vue?vue&type=script&lang=ts&"
import style0 from "./Setup2FA.vue?vue&type=style&index=0&id=1ea95b9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea95b9b",
  null
  
)

export default component.exports